import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

// Color logos

export const partnerLogos = [
  {
    partner_logo: {
      url: 'https://res.cloudinary.com/cryptr/image/upload/v1644947330/Cryptr%20www/Campaign%20landing%20pages/Partner%20logos/sarbacane_logo_obaq6y.svg',
      website_link: 'https://sarbacane.com/',
      alt: 'Sarbacane',
    },
  },
  {
    partner_logo: {
      url: 'https://res.cloudinary.com/cryptr/image/upload/v1644947330/Cryptr%20www/Campaign%20landing%20pages/Partner%20logos/tradein_logo_gb9nzo.svg',
      website_link: 'https://www.tradeinsur.com/',
      alt: 'TradeIn',
    },
  },
  {
    partner_logo: {
      url: 'https://res.cloudinary.com/cryptr/image/upload/v1644947330/Cryptr%20www/Campaign%20landing%20pages/Partner%20logos/foxy_nerds_logo_wldlsr.svg',
      website_link: 'https://www.foxynerds.com/',
      alt: 'FoxyNerds',
    },
  },
  {
    partner_logo: {
      url: 'https://res.cloudinary.com/cryptr/image/upload/v1644947330/Cryptr%20www/Campaign%20landing%20pages/Partner%20logos/merciyanis_logo_ete4vb.png',
      website_link: 'https://www.merciyanis.com/',
      alt: 'MerciYanis',
    },
  },
  {
    partner_logo: {
      url: 'https://res.cloudinary.com/cryptr/image/upload/v1644947330/Cryptr%20www/Campaign%20landing%20pages/Partner%20logos/talentview_logo_sefzip.png',
      website_link: 'https://www.talentview.fr/',
      alt: 'TalentView',
    },
  },
]

export const samlSsoImage = {
  illustration: (
    <StaticImage
      src="https://res.cloudinary.com/cryptr/image/upload/v1645004251/Cryptr%20www/Campaign%20landing%20pages/what_is_saml_i2ru3w.png"
      alt="Saml SSO"
      quality={95}
      formats={['auto', 'webp', 'avif']}
      placeholder="none"
    />
  ),
}

export const ssoImage = {
  illustration: (
    <StaticImage
      src="https://res.cloudinary.com/cryptr/image/upload/v1644944946/Cryptr%20www/Campaign%20landing%20pages/sso_how_it_works_o5htv4.png"
      alt="Sso"
      quality={95}
      formats={['auto', 'webp', 'avif']}
      placeholder="none"
    />
  ),
}

export const activeDirectoryImage = {
  illustration: (
    <StaticImage
      src="https://res.cloudinary.com/cryptr/image/upload/v1645004254/Cryptr%20www/Campaign%20landing%20pages/active_directory_lf7xta.png"
      alt="Active Directory"
      quality={95}
      formats={['auto', 'webp', 'avif']}
      placeholder="none"
    />
  ),
}

export const perksSsoImage = {
  illustration: (
    <StaticImage
      src="https://res.cloudinary.com/cryptr/image/upload/v1662380892/Cryptr%20www/Campaign%20landing%20pages/perks_sso_selfservice_uz7rpf.png"
      alt="Perks SSO"
      quality={95}
      formats={['auto', 'webp', 'avif']}
      placeholder="none"
    />
  ),
}

export const kimaPerksSsoImage = {
  illustration: (
    <StaticImage
      src="https://res.cloudinary.com/cryptr/image/upload/v1665148804/Cryptr%20www/Campaign%20landing%20pages/kima_perks_sso_selfservice_mipohw.png"
      alt="Perks SSO"
      quality={95}
      formats={['auto', 'webp', 'avif']}
      placeholder="none"
    />
  ),
}
